<template>
  <ModalVue
      :fields="[
            {
                name: 'email',
                type: 'email',
                tag: 'input',
                placeholder: 'adres e-mail',
                req: true,
                value: editUser.email,
                label: 'adres e-mail'
            }
        ]"
      title="Edytuj dane"
      button-text="Zatwierdź"
      :isVisible="editUser.showModal"
      @closeModal="() => { editUser.showModal = false; }"
      @sendData="(data) => handleEditUser(data)"
  />

  <div v-if="currentUser" class="users-admin">
    <div class="page-header">
      <h1>Użytkownicy</h1>
      <div class="header-actions">
        <button class="btn-outline" @click="resetFilters">Resetuj filtry</button>
        <button class="btn-primary" @click="getUsersData">Odśwież listę</button>
      </div>
    </div>

    <div class="section-card">
      <div class="section-card-header">
        <h2>Wyszukiwanie i filtrowanie</h2>
        <div class="filters-grid">
          <div class="form-group">
            <label for="filterType">Szukaj po</label>
            <select id="filterType" v-model="searcher.choosedFilter">
              <option value="">Wybierz filtr</option>
              <option :value="item.value" v-for="(item, index) in searcher.filters" :key="index">
                {{ item.name }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label for="searchPhrase">Fraza</label>
            <input
                id="searchPhrase"
                type="text"
                v-model="searcher.searchPhrase"
                :disabled="!searcher.choosedFilter"
                :placeholder="searchPlaceholder"
                @keyup.enter="filterUsers"
            >
          </div>

          <div class="form-group">
            <label for="usersLimit">Pokaż na stronie</label>
            <select id="usersLimit" v-model.number="usersList.limit" @change="onLimitChange">
              <option :value="10">10</option>
              <option :value="16">16</option>
              <option :value="22">22</option>
              <option :value="28">28</option>
              <option :value="34">34</option>
            </select>
          </div>

          <div class="form-group">
            <label for="usersPage">Numer strony</label>
            <input
                id="usersPage"
                type="number"
                min="1"
                :max="totalPages"
                v-model.number="pageInput"
                placeholder="Wpisz numer strony"
                @keyup.enter="goToPage"
            >
          </div>
        </div>

        <div class="filters-actions">
          <button class="btn-green" @click="filterUsers">Szukaj</button>
          <button class="btn-outline" @click="goToPage">Pobierz stronę</button>
          <button class="btn-outline" @click="resetFilters">Resetuj</button>
          <img v-if="searcher.loading" class="loading" src="@/assets/icons/loading.gif" alt="ładowanie">
        </div>
      </div>

      <div class="toolbar-row">
        <div class="results-chip">
          Wyniki: <b>{{ usersList.usersCount || 0 }}</b>
        </div>

        <div class="pagination">
          <button class="btn-outline" @click="prevPage" :disabled="usersList.page <= 1">
            &#8592; Poprzednia
          </button>
          <span class="page-info">
            Strona {{ usersList.page }} / {{ totalPages }}
          </span>
          <button class="btn-outline" @click="nextPage" :disabled="usersList.page >= totalPages">
            Następna &#8594;
          </button>
        </div>
      </div>
    </div>

    <div class="section-card table-card position-relative">
      <div class="section-card-header">
        <HintComponent page-key="admin_panel_users" :absolute="true"/>
        <h2>Lista kont</h2>
      </div>

      <div v-if="!usersList.usersList" class="empty-state">
        <p>Ładowanie użytkowników...</p>
      </div>

      <div v-else-if="usersList.usersList.length === 0" class="empty-state">
        <p>Brak użytkowników do wyświetlenia.</p>
      </div>

      <div v-else class="table-wrapper">
        <table class="users-table">
          <thead>
          <tr>
            <th>ID</th>
            <th>Typ konta</th>
            <th>Specjalizacja</th>
            <th>E-mail</th>
            <th>Telefon</th>
            <th>Akcje</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="user in usersList.usersList" :key="user.id">
            <td>{{ user.id }}</td>
            <td>
              <span class="role-chip">{{ getRoleLabel(user.role && user.role.id) }}</span>
            </td>
            <td>
              {{ user.category ? user.category.name : 'brak' }}
            </td>
            <td>
              <RouterLink class="email-link" :to="`/browse/user/${user.id}`">
                {{ user.email }}
              </RouterLink>
            </td>
            <td>{{ user.phone ? user.phone : 'brak' }}</td>
            <td>
              <div class="user-actions-btns">
                <button class="btn-warning" @click="() => openEditModal(user.id, user.email)">Edytuj</button>
                <button class="btn-green" @click="() => sendActivationMail(user.id)">Mail aktyw.</button>
                <button class="btn-danger" @click="() => deleteUser(user.id)">Usuń</button>
                <button v-if="user.active" class="btn-danger" @click="() => disableUser(user.id)">Blokuj</button>
                <button v-else class="btn-blue" @click="() => enableUser(user.id)">Odblokuj</button>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import ModalVue from '@/components/Modal.vue';
import authHeader from '@/services/auth-header';
import axios from 'axios';
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';
import HintComponent from "@/components/SpecialComponents/HintComponent.vue";

export default {
  name: 'UsersList',
  components: {HintComponent, ModalVue },
  setup() {
    return {
      authStore: useAuthStore(),
      appStore: useAppStore(),
    };
  },
  data() {
    return {
      searcher: {
        searchPhrase: '',
        choosedFilter: '',
        loading: false,
        filters: [
          { name: 'adres e-mail', value: 'email' },
          { name: 'imię i nazwisko', value: 'name' },
        ],
      },
      usersList: {
        usersList: null,
        page: 1,
        limit: 10,
        usersCount: 0,
      },
      pageInput: 1,
      downloading: false,
      editUser: {
        id: null,
        showModal: false,
        email: '',
      },
    };
  },
  props: ['isVisible'],
  computed: {
    currentUser() {
      return this.authStore.user;
    },
    totalPages() {
      const pages = Math.ceil((this.usersList.usersCount || 0) / this.usersList.limit);
      return pages > 0 ? pages : 1;
    },
    searchPlaceholder() {
      if (!this.searcher.choosedFilter) return 'Najpierw wybierz filtr';
      const chosen = this.searcher.filters.find(item => item.value === this.searcher.choosedFilter);
      return chosen ? chosen.name : 'Wpisz frazę';
    },
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    } else if (this.currentUser.role_id !== 1) {
      this.$router.push('/login');
    }
    this.getUsersData();
  },
  methods: {
    getUsersData() {
      const ob = {
        page: this.usersList.page,
        limit: this.usersList.limit,
      };

      axios.post('/Users', ob)
          .then(res => {
            this.usersList.usersList = res.data.items || [];
            this.usersList.usersCount = res.data.count || 0;
            this.pageInput = this.usersList.page;
          })
          .catch(() => {
            this.usersList.usersList = [];
            this.usersList.usersCount = 0;
            this.appStore.setIsAlert('Nie udało się pobrać listy użytkowników');
          });
    },
    filterUsers() {
      this.searcher.loading = true;

      const ob = {
        page: this.usersList.page,
        limit: this.usersList.limit,
      };

      if (this.searcher.choosedFilter === 'email') {
        ob.email = this.searcher.searchPhrase;
      }
      if (this.searcher.choosedFilter === 'name') {
        ob.name = this.searcher.searchPhrase;
      }

      axios.post('/Users', ob)
          .then(res => {
            this.usersList.usersCount = res.data.count || 0;
            this.usersList.usersList = res.data.items || [];
            this.pageInput = this.usersList.page;
          })
          .catch(() => {
            this.appStore.setIsAlert('Nie udało się przefiltrować użytkowników');
          })
          .finally(() => {
            this.searcher.loading = false;
          });
    },
    resetFilters() {
      this.searcher.searchPhrase = '';
      this.searcher.choosedFilter = '';
      this.usersList.page = 1;
      this.pageInput = 1;
      this.getUsersData();
    },
    onLimitChange() {
      this.usersList.page = 1;
      this.pageInput = 1;
      this.filterUsers();
    },
    goToPage() {
      let page = Number(this.pageInput);

      if (!page || page < 1) {
        page = 1;
      }

      if (page > this.totalPages) {
        page = this.totalPages;
      }

      this.usersList.page = page;
      this.pageInput = page;
      this.filterUsers();
    },
    prevPage() {
      if (this.usersList.page > 1) {
        this.usersList.page -= 1;
        this.pageInput = this.usersList.page;
        this.filterUsers();
      }
    },
    nextPage() {
      if (this.usersList.page < this.totalPages) {
        this.usersList.page += 1;
        this.pageInput = this.usersList.page;
        this.filterUsers();
      }
    },
    openEditModal(id, email) {
      this.editUser.showModal = true;
      this.editUser.id = id;
      this.editUser.email = email;
    },
    getRoleLabel(roleId) {
      if (roleId === 2) return 'specjalista';
      if (roleId === 3) return 'usługobiorca';
      if (roleId === 4) return 'pracownik';
      return 'placówka';
    },
    deleteUser(id) {
      const input = prompt('potwierdź wpisując tak');
      if (input === 'tak') {
        axios.delete(`/User/${id}`, authHeader()).then(() => {
          this.appStore.setIsSuccess('Pomyślnie usunięto użytkownika');
          setTimeout(() => {
            this.getUsersData();
          }, 500);
        });
      }
    },
    handleEditUser(data) {
      axios.get(`/User/${this.editUser.id}`).then(res => {
        const ob = {
          id: res.data.id,
          email: data.email,
          firstname: res.data.firstname,
          lastname: res.data.lastname,
          name: res.data.name,
          phone: res.data.phone,
          address: res.data.address,
          nip: res.data.nip,
          phone_2: res.data.phone2,
          description: res.data.description,
          short_description: res.data.short_description,
          krs: res.data.krs,
          regon: res.data.regon,
          pzw_number: res.data.pzw,
        };

        ob.category_id = res.data.category ? res.data.category.id : null;
        ob.state_id = res.data.state ? res.data.state.id : null;

        axios.post('/UserProfile', ob, authHeader()).then(() => {
          this.appStore.setIsSuccess('Pomyślnie zmieniono dane');
          const found = this.usersList.usersList.find(user => user.id === res.data.id);
          if (found) found.email = data.email;
        }).catch(() => {
          this.appStore.setIsAlert('Nie udało się zmienić danych');
        });
      }).catch(() => {
        this.appStore.setIsAlert('Nie udało się pobrać danych użytkownika');
      });
    },
    sendActivationMail(id) {
      axios.get(`/SendActivationMail/${id}`, authHeader()).then(() => {
        this.appStore.setIsSuccess('Pomyślnie wysłano maila aktywacyjnego');
      }).catch(() => {
        this.appStore.setIsAlert('Nie udało się wysłać maila aktywacyjnego');
      });
    },
    disableUser(id) {
      axios.get(`/admin/disable-user/${id}`, authHeader()).then(() => {
        this.appStore.setIsSuccess('Pomyślnie zablokowano użytkownika');
        const found = this.usersList.usersList.find(user => user.id === id);
        if (found) found.active = false;
      }).catch(() => {
        this.appStore.setIsAlert('Nie udało się zablokować użytkownika');
      });
    },
    enableUser(id) {
      axios.get(`/admin/enable-user/${id}`, authHeader()).then(() => {
        this.appStore.setIsSuccess('Pomyślnie odblokowano użytkownika');
        const found = this.usersList.usersList.find(user => user.id === id);
        if (found) found.active = true;
      }).catch(() => {
        this.appStore.setIsAlert('Nie udało się odblokować użytkownika');
      });
    }
  }
};
</script>

<style scoped>
.users-admin {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 16px;
  font-family: sans-serif;
  box-sizing: border-box;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}

.page-header h1 {
  font-size: 2.8rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.header-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.section-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
  padding: 24px;
  box-sizing: border-box;
  width: 100%;
  margin-bottom: 20px;
}

.section-card-header {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 14px;
}

.section-card h2 {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.filters-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(180px, 1fr));
  gap: 10px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group label {
  font-size: 1.4rem;
  font-weight: 600;
  color: #374151;
}

.form-group input,
.form-group select {
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 1.4rem;
  outline: none;
  transition: border-color 0.2s;
  box-sizing: border-box;
  width: 100%;
}

.form-group input:focus,
.form-group select:focus {
  border-color: #10b981;
}

.filters-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.loading {
  width: 30px;
  height: 30px;
  object-fit: contain;
}

.toolbar-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding-top: 8px;
  border-top: 1px solid #e5e7eb;
}

.results-chip {
  font-size: 1.4rem;
  color: #374151;
  background: #f3f4f6;
  border-radius: 999px;
  padding: 6px 12px;
}

.pagination {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.page-info {
  font-size: 1.5rem;
  color: #6b7280;
  font-weight: 500;
  min-width: 130px;
  text-align: center;
}

.table-card {
  margin-bottom: 0;
}

.table-wrapper {
  width: 100%;
  overflow-x: auto;
}

.users-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  min-width: 760px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
}

.users-table thead th {
  background-color: #f9fafb;
  color: #374151;
  font-size: 1.4rem;
  font-weight: 700;
  text-align: left;
  padding: 12px;
  border-bottom: 1px solid #e5e7eb;
}

.users-table tbody td {
  padding: 12px;
  font-size: 1.4rem;
  color: #1f2937;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: middle;
}

.users-table tbody tr:last-child td {
  border-bottom: none;
}

.users-table tbody tr:hover td {
  background-color: #fcfcfd;
}

.role-chip {
  display: inline-block;
  background-color: #d1fae5;
  color: #065f46;
  font-size: 1.2rem;
  font-weight: 600;
  padding: 2px 10px;
  border-radius: 20px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.email-link {
  color: #2563eb;
  text-decoration: none;
  word-break: break-word;
}

.email-link:hover {
  text-decoration: underline;
}

.user-actions-btns {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.empty-state {
  text-align: center;
  padding: 28px;
  color: #9ca3af;
  font-size: 1.5rem;
  border: 1px dashed #d1d5db;
  border-radius: 10px;
}

.btn-primary {
  background-color: #f97316;
  color: #fff;
  padding: 10px 20px;
  border-radius: 8px;
  border: none;
  font-size: 1.5rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-primary:hover {
  background-color: #ea6c0a;
}

.btn-green {
  background-color: #10b981;
  color: #fff;
  padding: 8px 16px;
  border-radius: 8px;
  border: none;
  font-size: 1.4rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-green:hover {
  background-color: #059669;
}

.btn-outline {
  background-color: transparent;
  color: #1f2937;
  padding: 8px 16px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  font-size: 1.4rem;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s;
}

.btn-outline:hover {
  border-color: #10b981;
  color: #10b981;
}

.btn-danger {
  background-color: #dc3545;
  color: #fff;
  padding: 7px 10px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1.3rem;
  font-weight: 600;
}

.btn-warning {
  background-color: #ffc107;
  color: #1f2937;
  padding: 7px 10px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1.3rem;
  font-weight: 600;
}

.btn-blue {
  background-color: #2563eb;
  color: #fff;
  padding: 7px 10px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1.3rem;
  font-weight: 600;
}

button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (max-width: 900px) {
  .filters-grid {
    grid-template-columns: 1fr;
  }

  .toolbar-row {
    flex-direction: column;
    align-items: stretch;
  }

  .pagination {
    justify-content: space-between;
  }
}

@media (max-width: 480px) {
  .users-admin {
    padding: 16px 12px;
  }

  .page-header h1 {
    font-size: 2.2rem;
  }

  .section-card {
    padding: 16px 12px;
    border-radius: 8px;
  }

  .section-card h2 {
    font-size: 1.8rem;
  }

  .btn-primary,
  .btn-green,
  .btn-outline {
    width: 100%;
    text-align: center;
  }

  .header-actions {
    width: 100%;
  }

  .filters-actions {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>